import React from "react";
import HrEvaluationTable from "../../components/Dashboard/Tables/HrEvaluationTable";
import { MenuItem, Select } from "@mui/material";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { tabStyle,menuItemStyle, SelectInputStyle } from "../../components/Dashboard/Tables/Styles";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box >
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function HrEvaluation() {
  const [status, setStatus] = React.useState("showAll");

  const handleChange = (event) => {
    setStatus(event.target.value);
  };

  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (_event, newValue) => {
    setTabValue(newValue);
  };


  //Styles
 

  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <div className="flex flex-col lg:flex-row gap-6 justify-between items-baseline bg-white pl-0 pr-6 pb-6 pt-6 ">
          <div>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="basic tabs example"
              
            >
              <Tab  sx={tabStyle} label="90 Days" {...a11yProps(0)} />
              <Tab sx={tabStyle}  label="Annual" {...a11yProps(1)} />
            </Tabs>
          </div>
          <div className="flex justify-end gap-4 flex-col md:flex-row ">
            <div className="flex gap-4 items-center ">
              <p className="font-medium font-sans leading-normal text-[10px] not-italic text-[#98A2B3] ml-2 lg:ml-0">Filter by:</p>
              <Select
                value={status}
                onChange={handleChange}
                className="w-[190px] h-12 py-3 px-4"
                sx={SelectInputStyle}
              >
                <MenuItem sx={menuItemStyle}  value={"showAll"}>Show All</MenuItem>
                <MenuItem sx={menuItemStyle} value={"active"}>Active</MenuItem>
                <MenuItem sx={menuItemStyle} value={"inactive"}>Inactive</MenuItem>
              </Select>
            </div>
          </div>
        </div>
        <CustomTabPanel value={tabValue} index={0}>
          <HrEvaluationTable />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <HrEvaluationTable />
        </CustomTabPanel>
      </Box>
    </div>
  );
}

export default HrEvaluation;
